// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { searchInputStyles } from "@synd/Overrides/Widgets/Header/HeaderSearchInput";
import { color } from "@synd/XDL/Utilities";
import { css } from "styled-components";

searchInputStyles.searchWrapper = {
    css: css`
        ${({ iconMode, isOpen }: any) =>
            iconMode &&
            css`
                position: absolute;
                display: flex;
                column-gap: 12px;
                background-color: ${color("common.ui1")};
                top: 100%;
                left: 0;
                box-shadow: 0 1px 0 0 ${color("common.border")};
                padding: 24px 16px 16px;
                width: 100%;
                margin-top: 1px;
                z-index: 1;
                > [data-state] {
                    flex: 1;
                }
                ${!isOpen ? "display: none;" : ""}
            `}
    `,
};
